import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerForecastHistoryNotificationsSlice = createApi('GetBuyerForecastHistoryNotificationsSlice', 'GET');

const GetBuyerForecastHistoryNotificationsSlice = createSlice({
  name: 'GetBuyerForecastHistoryNotificationsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerForecastHistoryNotificationsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerForecastHistoryNotificationsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerForecastHistoryNotificationsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetBuyerForecastHistoryNotificationsSlice.reducer;
